import { getDomain } from 'general/helpers/DomainHelper'

//  Tổ chức cung cấp dịch vụ
export const serviceProviderColumns = [
  { key: 'unitName', title: 'Tên tổ chức cung cấp dịch vụ' },
  { key: 'taxCode', title: 'Mã số thuế' },
  {
    title: 'Thời gian',
    isGroupHeader: true,
    colSpan: 2,
  },
  { key: 'fromDate', title: 'Từ ngày', groupName: 'Thời gian' },
  { key: 'toDate', title: 'Đến ngày', groupName: 'Thời gian' },
  { key: 'note', title: 'Ghi chú' },
]

// Thông tin đơn vị truyền nhận
export const EInvoiceConnectorColumns = [
  { key: 'unitName', title: 'Tên đơn vị truyền nhận' },
  { key: 'taxCode', title: 'Mã số thuế' },
  {
    title: 'Thời gian',
    isGroupHeader: true,
    colSpan: 2,
  },
  {
    key: 'fromDate',
    title: 'Từ ngày',
    groupName: 'Thời gian',
    tooltip:
      'Từ ngày phải lớn hơn hoặc bằng ngày bắt đầu cung cấp dịch vụ của đơn vị truyền nhận theo công bố của Cục Thuế.',
  },
  { key: 'toDate', title: 'Đến ngày', groupName: 'Thời gian' },
  { key: 'note', title: 'Ghi chú' },
]

// Thông tin đơn vị hạch toán phụ thuộc cần cấp quyền tra cứu hóa đơn
export const DependentUnitsInvoiceAccess = [
  { key: 'unitName', title: 'Tên đơn vị' },
  { key: 'taxCode', title: 'Mã số thuế' },
  {
    title: 'Thời gian',
    isGroupHeader: true,
    colSpan: 2,
  },
  { key: 'fromDate', title: 'Từ ngày', groupName: 'Thời gian' },
  { key: 'toDate', title: 'Đến ngày', groupName: 'Thời gian' },
  { key: 'note', title: 'Ghi chú' },
]

// đề nghị tạm ngừng sử dụng hóa đơn điện tử
export const EInvoiceSuspendRequest = [
  {
    title: 'Thời gian tạm ngừng sử dụng hóa đơn điện tử',
    isGroupHeader: true,
    colSpan: 2,
  },
  { key: 'fromDate', title: 'Từ ngày', groupName: 'Thời gian' },
  { key: 'toDate', title: 'Đến ngày', groupName: 'Thời gian' },
  { key: 'unitName', title: 'Tên tổ chức cung cấp dịch vụ' },
  { key: 'taxCode', title: 'MST tổ chức cung cấp dịch vụ' },
  { key: 'serialNumber', title: 'Số seri chứng thư số' },
  { key: 'note', title: 'Ghi chú' },
]

// Chung code với IGAS
export const defaultServiceProviderValue = () => {
  const domain = getDomain()
  switch (domain) {
    case 'hoadon.igas.vn':
      return [
        {
          unitName: 'CÔNG TY CỔ PHẦN GIẢI PHÁP SỐ IGAS',
          taxCode: '0111090707',
        },
      ]

    case 'hoadon.gohoadon.vn':
      return [
        {
          unitName: 'CÔNG TY CỔ PHẦN CÔNG NGHỆ GO VIỆT NAM',
          taxCode: '0111245245',
        },
      ]
    default:
      return [{ unitName: 'CÔNG TY CỔ PHẦN ICORP', taxCode: '0106870211' }]
  }
}

export const defaultEInvoiceConnectorValue = [
  {
    unitName: 'CÔNG TY TNHH WIN TECH SOLUTION',
    taxCode: '0312303803',
  },
]
